"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const set_modal_1 = __importDefault(require("../action/set-modal"));
const store_1 = __importDefault(require("../store"));
exports.default = (type, data, onCancel) => async (dispatch) => {
    const { modal } = store_1.default.getState();
    if (!type && modal?.data?.noClose) {
        return;
    }
    if (!type) {
        dispatch((0, set_modal_1.default)(null));
        return;
    }
    // clear the existing modal first, before loading a new one
    dispatch((0, set_modal_1.default)(null));
    dispatch((0, set_modal_1.default)({
        type,
        data,
        onCancel,
    }));
    // deselect text after opening the modal
    // (sometimes, when opening the modal by double-clicking the calendar event, the browser selects a bunch of text within it - this deselects it back)
    if (window.getSelection) {
        window.getSelection()?.removeAllRanges();
    }
};
